<template>
  <div
    v-if="goal_expanded"
    class="relative p-4 mb-4 border rounded-md dark:bg-dark-screen-background dark:border-dark-divider-border dark:text-white">
    <div class="flex items-center">
      <ToggleStatusButton :object="goal" />

      <div class="flex ml-2">
        <div>{{ goal.name }}</div>
        <Badge :icon="task_icon" :object="goal" :list-name="'tasks'" />
      </div>
      <div class="absolute flex -right-3 -top-3 gap-x-2">
        <div
          class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
          @click="goal_expanded = !goal_expanded">
          <div class="w-[15px] h-[15px] ml-[5px] mt-[0px] border-b-[3px] border-b-[#45D72D]" />
          <span
            class="items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrapinline-flex bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
            {{ $t("Minimize") }}</span>
        </div>
        <div
          class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:bg-dark-screen-background dark:border-dark-divider-border"
          @click="handleViewGoal(goal)">
          <Maximize2 class="w-5 h-5 ml-[3px] mt-[3px] transition ease-in-out duration-side-menu-transition-duration" color="#2DA7D7" />
          <span
            class="tooltip whitespace-nowrap inline-flex items-center px-2 py-1 rounded-md text-sm w-[80px] bg-light-screen-background dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
            {{ $t("View Goal") }}</span>
        </div>
        <!-- <div
          class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
          @click="handleRemoveGoal(goal)">
          <X
            color="#FF0000"
            class="w-3 h-3 ml-[7px] mt-[7px] transition ease-in-out duration-side-menu-transition-duration" /><span
              class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
              Remove</span>
        </div> -->
      </div>
    </div>
    <div class="flex w-full mt-5">
      <div class="w-[40%] mt-2">
        <div class="flex">
          <div class="flex gap-x-2">
            <div v-if="goal?.filter" class="text-common-grey">
              {{ $t("Progress") }}:
            </div>
            <div v-else class="text-sm text-common-grey">
              {{ $t("No filter specified for this goal") }}
            </div>
            <div v-if="goal?.filter" class="font-light text-md dark:text-white">
              {{
                goal?.record.values[goal.filter.split(" ")[1]]
                  ? $utils.truncateNumber(parseInt(goal?.record.values[goal.filter.split(" ")[1]]))
                  : 0
              }}/{{ $utils.truncateNumber(parseInt(goal.filter.split(" ")[goal.filter.split(" ").length - 2])) }}
              {{ $utils.getMetricByReferenceName(goal.filter.split(" ")[1])?.name }}
            </div>
          </div>
          <div v-if="goal?.record?.values[goal.filter?.split(' ')[1]]" class="ml-auto text-lg">
            {{
              Math.round(
                (parseInt(goal?.record.values[goal.filter.split(" ")[1]]) /
                  parseInt(goal.filter.split(" ")[goal.filter.split(" ").length - 2])) *
                  100
              )
            }}%
          </div>
        </div>

        <div v-if="goal.filter" class="py-4 -mt-3 text-sm text-gray-500 whitespace-nowrap">
          <div class="w-full h-2 bg-gray-300 rounded-full dark:bg-dark-box-background">
            <div
              :style="{
                width: `${
                  (goal?.record.values[goal.filter.split(' ')[1]] ? goal?.record.values[goal.filter.split(' ')[1]] : 0) /
                  goal.filter.split(' ')[goal.filter.split(' ').length - 2] >
                  1
                    ? 100
                    : `${
                      (goal?.record.values[goal.filter.split(' ')[1]] ? goal?.record.values[goal.filter.split(' ')[1]] : 0) /
                      goal.filter.split(' ')[goal.filter.split(' ').length - 2]
                    }` * 100
                }%`
              }"
              :class="[` rounded-full bg-blue h-2`]" />
          </div>
        </div>
      </div>
      <div class="ml-20 w-[10%]">
        <div class="flex flex-row items-center gap-2">
          <div class="text-common-grey whitespace-nowrap">
            {{ $t("Due Date") }}:
          </div>

          <div class="flex items-start justify-start w-1/12 py-2 text-start whitespace-nowrap text-md">
            <span v-if="goal.due_date">
              {{ $moment(goal.due_date).format("DD MMM  YYYY") }}
            </span>

            <span v-else> - </span>
          </div>
        </div>
      </div>

      <div :class="[`${goal.assigned_to.length > 4 ? 'w-[16%]' : ''}`]" class="ml-auto -mt-8">
        <div :class="[`${goal.assigned_to.length > 4 ? '' : '-ml-10'}`]" class="mb-2 text-common-grey whitespace-nowrap text-start">
          {{ $t("Team Members") }}
        </div>
        <div class="flex items-center -ml-5 -space-x-4 overflow-hidden">
          <span v-for="user in goal.assigned_to.slice(0, 4)" :key="user.id" class="inline-block has-tooltip">
            <img v-if="user.avatar" class="inline-block rounded-full h-9 w-9 object-cover" :src="user.avatar" alt="">
            <Avatar v-else :first-name="user.first_name" :last-name="user.last_name" />
            <span class="p-1 bg-gray-300 rounded-sm tooltip whitespace-nowrap">
              <div class="">
                <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
                  {{ Record.from(user).full_name }}
                </p>
              </div>
            </span>
          </span>
          <span v-if="goal.assigned_to.length > 4" class="relative ml-auto text-sm left-6 text-light-brand-blue dark:text-dark-brand-blue">
            + {{ goal.assigned_to.length - 4 }} {{ $t("more") }}</span>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="relative flex p-4 mb-4 align-middle border rounded-md dark:bg-dark-screen-background dark:border-dark-divider-border dark:text-white">
    <div
      :class="[
        'w-4 h-4 rounded-full mt-1 mr-4 relative',
        {
          'bg-dark-brand-blue': ['in-progress', 'pending'].includes(goal.status),
          'bg-status-warning-yellow': goal.status == 'overdue',
          'bg-status-success-green': goal.status == 'completed',
          'bg-status-error-red': ['cancelled', 'missed'].includes(goal.status)
        }
      ]" />

    <div class="flex ml-2">
      <div>{{ goal.name }}</div>
      <Badge :icon="task_icon" :object="goal" :list-name="'tasks'" />
    </div>
    <div class="ml-auto mr-20">
      <div v-if="goal?.record?.values[goal.filter?.split(' ')[1]]" class="ml-auto text-md text-common-grey">
        {{
          Math.round(
            (parseInt(goal?.record.values[goal.filter.split(" ")[1]]) /
              parseInt(goal.filter.split(" ")[goal.filter.split(" ").length - 2])) *
              100
          )
        }}%
      </div>
    </div>
    <div class="absolute flex -right-3 -top-3 gap-x-2">
      <div
        class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
        @click="goal_expanded = !goal_expanded">
        <div class="w-[15px] h-[15px] ml-[5px] mt-[5px] border-[3px] rounded-md border-[#45D72D]" />
        <span
          class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
          {{ $t("Expand") }}</span>
      </div>
      <div
        class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:bg-dark-screen-background dark:border-dark-divider-border"
        @click="handleViewGoal(goal)">
        <Maximize2 class="w-5 h-5 ml-[3px] mt-[3px] transition ease-in-out duration-side-menu-transition-duration" color="#2DA7D7" />
        <span
          class="tooltip whitespace-nowrap inline-flex items-center px-2 py-1 rounded-md text-sm w-[80px] bg-light-screen-background dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
          {{ $t("View Goal") }}</span>
      </div>
      <!-- <div
        class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
        @click="handleRemoveGoal(goal)">
        <X
          color="#FF0000"
          class="w-3 h-3 ml-[7px] mt-[7px] transition ease-in-out duration-side-menu-transition-duration" /><span
            class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
            Remove</span>
      </div> -->
    </div>
  </div>
</template>

<script>
import ToggleStatusButton from "@/components/shared/ToggleStatusButton.vue"
import Badge from "@/components/shared/ActivityStatusBadge.vue"
//eslint-disable-next-line
import { ClipboardCheck, Maximize2 } from "lucide-vue-next"
import { markRaw } from "vue"
import Avatar from "@/components/shared/Avatar.vue"
import { Record } from "@/models/record"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    ToggleStatusButton,
    Badge,
    //eslint-disable-next-line
    ClipboardCheck: markRaw(ClipboardCheck),
    Maximize2,
    //  X,
    Avatar
  },
  props: {
    goal: null
  },
  emits: [],
  data() {
    return {
      goal_expanded: false,
      task_icon: ClipboardCheck,
      Record
    }
  },
  watch: {},

  created() {},

  methods: {
    handleViewGoal(goal) {
      this.$emitter.emit(ALL_EMITTERS.UPDATE_GOAL, {
        goal: this.$utils.clone(goal)
      })
    }
  }
}
</script>
